<div class="fx_modal_container" appModalDrag>
  <div class="fx_modal_title">
    <div class="fx_le_title">
      <i class="anticon anticon-picture"></i>
      <span>{{title}}</span>
    </div>
    <div class="fx_ri_full">
      <i class="anticon anticon-close fx_modal_close_btn" (click)="fxCloseModal()"></i>
    </div>
  </div>
  <div class="fx-modal-icon-picker">
    <div dw-row dwType="flex" dwGutter="16" dwJustify="center">
      <div dw-col dwSpan="7" class="icon-preview">
        <dw-select dw-input [(ngModel)]="namespace" (ngModelChange)="getIcons(namespace)"
          style="margin-top: 8px; margin-bottom: 8px;">
          <dw-option dwValue="material-icons" dwLabel="MATERIAL_ICONS"></dw-option>
          <dw-option dwValue="anticon" dwLabel="ANTICON"></dw-option>
          <dw-option dwValue="iconfont" dwLabel="ICONFONT_ICON"></dw-option>
        </dw-select>
        <dw-card dwHoverable [dwCover]="coverTemplate" [style.display]="selectedIcon.id?'block':'none'" class="fx_cover_content">
          <dw-card-meta dwTitle="{{selectedIcon.id}}"></dw-card-meta>
        </dw-card>
        <ng-template #coverTemplate>
          <!--<img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"/>-->
          <!-- <i class="my-icon {{selectedIcon.class}}"></i> -->

          <ng-container *ngIf="selectedIcon.isSvg">
            <svg class="icon" aria-hidden="true">
              <use attr.xlink:href="#{{selectedIcon.id}}"></use>
            </svg>
          </ng-container>
          <ng-container *ngIf="selectedIcon.isSvg == undefined">
            <i class="{{selectedIcon.class}}"></i>
          </ng-container>

        </ng-template>
      </div>
      <div dw-col dwSpan="17" style="max-height: 480px;overflow-y: auto;">
        <dw-collapse [dwBordered]="false">
          <dw-collapse-panel *ngFor="let iconColletion of icons" [dwHeader]="iconColletion.type" [dwActive]="true">
            <div dw-row dwType="flex" dwGutter="8" dwAlign="middle" dwJustify="center">
              <div *ngFor="let icon of iconColletion.iconList" dw-col dwSpan="4" dwSm="4" dwXl="4" dwXs="4" dwXXl="4"
                class="icon-panel" [ngClass]="{'selected':icon === selectedIcon}" (click)="selectedIcon = icon">
                  
                  <ng-container *ngIf="iconColletion.isSvg">
                    <svg class="icon" aria-hidden="true">
                      <use attr.xlink:href="#{{icon.id}}"></use>
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="iconColletion.isSvg2">
                    <i class="{{icon.class}}"></i>
                  </ng-container>


              </div>
            </div>
          </dw-collapse-panel>
        </dw-collapse>
      </div>
    </div>
  </div>
  <div class="fx_modal_footer">
    <div dw-row>
      <div dw-col dwSpan="15">
        <span>{{ selectedIcon.id ? selectedIcon.class : '' }}</span>
      </div>
      <div dw-col dwSpan="9">
        <div dw-row dwType="flex" dwJustify="end" style="padding-right: 16px;">
          <button dw-button [dwType]="'default'" (click)="onClickCancel()">取消</button>
          <button dw-button [dwType]="'primary'" (click)="onClickOK()" [attr.disabled]="selectedIcon.class?null:''">确定
          </button>
        </div>
      </div>
    </div>
  </div>
</div>